<div *ngFor="let updatedGroup of changes | keyvalue" class="panel-container">
    <div class="panel-title-wrapper">
        <div class="panel-title">
            {{ updatedGroup.key }}
        </div>
        <div>{{ updatedGroup.value.category }}</div>
    </div>
    <div *ngFor="let update of updatedGroup.value.changes" class="change-container">
        {{ update.change }}
        <div class="change">
            <div>"{{ update.old }}"</div>
            <mat-icon svgIcon="arrow-right" class="arrow-icon" />
            <div>"{{ update.new }}"</div>
        </div>
    </div>
</div>
